export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer'
      },
      {
        // All maintenance / settings pages, grouped by category on one page.
        _name: 'CSidebarNavItem',
        name: 'Configuration',
        to: '/configuration',
        icon: 'cil-settings'
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Employees',
        route: '/manpowers',
        icon: 'cil-people',
        items: [
          {
            name: 'Add New',
            to: '/manpowers/add',
          },
          {
            name: 'Display All',
            to: '/manpowers/all',
          },
          {
            name: 'Cash Advances',
            to: '/manpowers/cash-advance',
          },
          {
            name: 'Payrolls',
            to: '/manpowers/payroll',
          },
          {
            name: 'Office Payroll',
            to: '/manpowers/office-payroll',
            roles: [1, 2],
          },
          {
            name: 'Preference Categories',
            to: '/manpowers/preference-categories',
          },
          {
            name: 'Awards',
            to: '/manpowers/awards',
          },
          {
            name: 'Leave Applications',
            to: '/manpowers/leave-applications',
          },
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Projects',
        route: '/projects',
        icon: 'cil-list',
        items: [
          {
            name: 'Add New',
            to: '/projects/add',
          },
          {
            name: 'Display All',
            to: '/projects/all',
          },
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Material Inventories',
        route: '/inventories',
        icon: 'cil-folder',
        items: [
          {
            name: 'Requests',
            to: '/inventories/requests',
          },
          {
            name: 'Purchases',
            to: '/inventories/purchases',
          },
          {
            name: 'Deliveries',
            to: '/inventories/deliveries',
          },
          {
            name: 'Transfers',
            to: '/inventories/transfers',
          },
          {
            name: 'Issuances',
            to: '/inventories/issuances',
          },
          {
            name: 'Withdrawals',
            to: '/inventories/withdrawals',
          },
          {
            name: 'Adjustments',
            to: '/inventories/adjustments',
          },
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Maintenance',
        route: '/maintenance-items',
        icon: 'cil-layers',
        items: [
          {
            name: 'Add New',
            to: '/maintenance-items/add',
          },
          {
            name: 'Display All',
            to: '/maintenance-items/all',
          }
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Export',
        route: '/export',
        icon: 'cil-chevron-bottom',
        items: [
          {
            name: 'Settings',
            to: '/export-settings',
          },
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Import',
        route: '/import-attendance',
        icon: 'cil-chevron-top',
        items: [
          {
            name: 'Attendance',
            to: '/import-attendance',
          },
          {
            name: 'For Approval',
            to: '/for-approval',
          },
        ]
      },
      {
        // Hub page with the Office Time Log and Site Time Log menus.
        _name: 'CSidebarNavItem',
        name: 'Time Log',
        to: '/timelog',
        icon: 'cil-clock'
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'User Manual',
        route: '/manual',
        icon: 'cil-file',
        roles: [1, 2],
        items: [
          {
            name: 'Office Time Log',
            to: '/manual/office-timelog',
            roles: [1, 2],
          },
        ]
      },
    ]
  }
]
